import React, {FC, useState} from "react"
import PropTypes from "prop-types"

import {useIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"
import History from "@irati/utils/history"
import authentication from "@irati/auth"

import BenefitsOverview from "../../../components/Reporting/Benefits/Overview"
import WellbeingEAP from "../../../components/Reporting/Wellbeing/EAP"
import {ANALYTICS_WELLBEING} from "../../../routes/routeConfig"

export enum WellbeingTabs {
  wellbeing = "wellbeing",
  onlineGP = "onlineGP",
  EAP = "EAP"
}

interface Props {}

interface Context {
  apps: {[key: string]: string}
}

const Wellbeing: FC<Props> = (_, {apps}: Context) => {
  const [activeKey, setActiveKey] = useState<string | undefined>(window.location.pathname.split("wellbeing/")?.[1])
  const {formatMessage} = useIntl()

  const handleOnChange = (value) => {
    History.push(`${ANALYTICS_WELLBEING}/${value}`, apps.ADMIN)
    setActiveKey(value)
  }

  const getTabs = () => {
    const {benefits, medical} = authentication.apps()
    const tabs = []

    if (medical?.onlineGP) {
      tabs.push({
        title: formatMessage({id: "admin.reporting.tabs.onlineGP"}),
        key: WellbeingTabs.onlineGP,
        component: <BenefitsOverview onlineGP />
      })
    }
    if (benefits?.eap) {
      tabs.push({
        title: formatMessage({id: "admin.reporting.tabs.eap"}),
        key: WellbeingTabs.EAP,
        component: <WellbeingEAP />
      })
    }
    return tabs
  }

  return (
    <Tabs
      id="adminSection_wellbeingTabs"
      addMarginTop
      mountOnEnter
      unmountOnExit
      activeKey={activeKey}
      onSelect={handleOnChange}
      tabs={getTabs()}
    />
  )
}

Wellbeing.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default Wellbeing
